import { render, staticRenderFns } from "./AvlList.vue?vue&type=template&id=728d25fa"
import script from "./AvlList.vue?vue&type=script&lang=js"
export * from "./AvlList.vue?vue&type=script&lang=js"
import style0 from "./AvlList.vue?vue&type=style&index=0&id=728d25fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports